import React, { useState } from 'react';
import styled from 'styled-components';
import AdminSidebar from './AdminSidebar';
import { Menu, X } from 'lucide-react'; // Dodajemo ikonicu za mobilni meni

const Container = styled.div`
  display: flex;
  min-height: 100vh;
  background: var(--background-dark);
  position: relative;
`;

const MobileMenuButton = styled.button`
  display: none;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1001;
  background: linear-gradient(95.36deg, #e0c16f 5.18%, #bd851b 93.21%);
  color: #000;
  border: none;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.5);
  cursor: pointer;
  align-items: center;
  justify-content: center;

  @media (max-width: 992px) {
    display: flex;
  }
`;

const SidebarWrapper = styled.div`
  @media (max-width: 992px) {
    position: fixed;
    top: 0;
    left: ${props => props.$isOpen ? '0' : '-100%'};
    height: 100vh;
    z-index: 1000;
    transition: left 0.3s ease-in-out;
    background: var(--background-dark);
    box-shadow: ${props => props.$isOpen ? '5px 0 15px rgba(0,0,0,0.5)' : 'none'};
  }
`;

const Main = styled.main`
  flex: 1;
  margin-left: 260px;
  min-height: 100vh;
  width: calc(100% - 260px);

  @media (max-width: 992px) {
    margin-left: 0;
    width: 100%;
  }
`;

const Topbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 28px;
  border-bottom: 1px solid var(--border-color);
  background: var(--background-dark);
  position: sticky;
  top: 0;
  z-index: 10;
  
  @media (max-width: 768px) {
    padding: 16px 20px;
  }
`;

const Title = styled.h1`
  color: var(--primary-gold);
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 28px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const Content = styled.div`
  padding: 24px 28px;
  max-width: 100%;
  overflow-x: hidden;

  @media (max-width: 768px) {
    padding: 16px 12px;
  }
`;

const AdminLayout = ({ active, onSelect, title, children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleSelect = (item) => {
    onSelect(item);
    setIsSidebarOpen(false); // Zatvori sidebar na telefonu kad se klikne link
  };

  return (
    <Container>
      <MobileMenuButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
        {isSidebarOpen ? <X size={24} /> : <Menu size={24} />}
      </MobileMenuButton>

      <SidebarWrapper $isOpen={isSidebarOpen}>
        <AdminSidebar active={active} onSelect={handleSelect} />
      </SidebarWrapper>

      <Main>
        <Topbar>
          <Title>{title}</Title>
        </Topbar>
        <Content>{children}</Content>
      </Main>
    </Container>
  );
};

export default AdminLayout;